const React = require('react');
const noop = require('mn-utils/noop');
const {Link} = require('../../../../../../router');
const Ripple = require('../../../../Ripple');

module.exports = ({className, text, icon, url, onClick, disabled, reverse}) => {
  const component = url ? Link : undefined;
  const href = url ? url : undefined;

  return (
    <Ripple
      className={
        ` w152 h45 layoutRow jcC aiC rlv r9 f12 fw7 cF bg2C2D30
          (abs|sr9|st50%|xY-50%)>.icon
          (c0|bgF).reverse
          (c0|fill0).reverse>.icon
          (o75).disabled
        ` + (className ? ` ${className}` : '')
          + (reverse ? ` reverse` : '')
          + (disabled ? ` disabled` : '')
      }
      component={component}
      href={href}
      onClick={onClick ? onClick : noop}
      disabled={disabled}
    >
      <span className="text">{text}</span>
      <div className="icon">
        {icon}
      </div>
    </Ripple>
  )
}
